import { Component } from '@angular/core';
import {BaseState} from "@base/entities/BaseEntities";
import {BaseComponent} from "@base/component/BaseComponent";
import {ServiceBagService} from "@base/component/ServiceBag";
import {ScreenService} from "@core/framework/screen.service";

class State extends BaseState {
    Types: any[];
    Styles: any[];
    SelectedType: 'default' | 'outlined' = 'outlined';
    SelectedStyle: 'light' | 'dark' = 'light';
    IsCollapsable: boolean = false;
    WithShadow: boolean = true;
    WithTitleAndIcon: boolean = true;
    WithCustomIcon: boolean = false;
    IsHeaderLink: boolean;
}

@Component({
    selector: 'app-demo-sections',
    templateUrl: './demo-sections.component.html',
    styleUrls: ['./demo-sections.component.scss', '../../styles/demo-styles.scss']
})
export class DemoSectionsComponent extends BaseComponent<State> {

    constructor(A: ServiceBagService, public screen: ScreenService) {
        super(A, 'DemoSectionsComponent', State);
    }
    
    protected override OnInitComponent() {
        this.State.Types = [
            {
                Text: "Default",
                Value: "default"
            },
            {
                Text: "Outlined",
                Value: "outlined"
            }
        ];
        
        this.State.Styles = [
            {
                Text: "Light",
                Value: "light"
            },
            {
                Text: "Dark",
                Value: "dark"
            }
        ];
    }

    GetSectionMarkup() : string {
        let result = '<m4u-section';
        
        if (this.State.WithTitleAndIcon)
            result += ' Label="{{\'YOUR_RESOURCE\' | RC:THIS}}"';

        if (this.State.WithTitleAndIcon && this.State.WithCustomIcon)
            result += ' Icon="mdi YOUR_CUSTOM_ICON"';
        
        if (this.State.SelectedType !== 'default')
            result += ` Type="${this.State.SelectedType}"`;
        
        if (this.State.SelectedStyle !== 'light')
            result += ` Style="${this.State.SelectedStyle}"`;
        
        if (this.State.WithTitleAndIcon && this.State.IsCollapsable)
            result += ' [IsCollapsable]="true"';
        
        if (this.State.WithShadow)
            result += ' [UseShadow]="true"';
        
        return result + '></m4u-section>'
    }

    OnHeaderClick(e) {
        console.log(e);
    }
}
